import { GenericAbortSignal } from 'axios'
import qs from 'qs'
import * as types from './club.types'
import { RESULTS_PER_PAGE } from '../../hooks/search/search'
import { ActiveFiltersInterface } from '../../interfaces/FiltersInterface'
import axios from '../../utils/axios'

export function auth(password: string) {
  return axios<any, types.ClubSignInResponse>({
    method: 'POST',
    url: '/club/auth.json',
    data: {
      password,
    },
  })
}

export function getClubData() {
  return axios<any, types.ClubGetClubResponse>({
    method: 'GET',
    url: '/club.json',
  })
}

export function searchOffers(page: number, perPage = RESULTS_PER_PAGE, fetchAllPages?: boolean) {
  return axios<any, types.ClubOffersResponse>({
    method: 'GET',
    url: `/club/offer.json?perPage=${perPage}&page=${page}&allPages=${Number(fetchAllPages)}`,
  })
}

export function searchFilteredOffers(
  page: number,
  filters: ActiveFiltersInterface | boolean = false,
  perPage = RESULTS_PER_PAGE,
  fetchAllPages?: boolean,
  abortSignal?: GenericAbortSignal,
) {
  const filtersParam = qs.stringify(filters, { encodeValuesOnly: true })
  return axios<any, types.ClubFilteredOffersResponse>({
    method: 'GET',
    url: `/club/offer/filtered.json?perPage=${perPage}&page=${page}&${filtersParam}&allPages=${Number(fetchAllPages)}`,
    signal: abortSignal,
  })
}
